import { render, staticRenderFns } from "./financeDetail.vue?vue&type=template&id=0bc79930"
import script from "./financeDetail.vue?vue&type=script&lang=js"
export * from "./financeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports